import { gql } from '@apollo/client';

export const STAFF_USERS = gql`
  query StaffUsers($filter: UsersFilter, $sort: UsersSort) {
    users(filter: $filter, sort: $sort) {
      count
      data {
        id
        contactNo
        email
        roles
        createdAt
        isActive
        isArchived
        firstName
        lastName
        userNumber
        libraryStaff {
          role
          isServiceable
          library {
            id
            name
            libraryNumber
          }
        }
      }
    }
  }
`;

export const STAFF_USER = gql`
  query StaffUser($where: UserUniqueInput!) {
    user(where: $where) {
      id
      email
      address
      address2
      locality
      city
      contactNo
      createdAt
      firstName
      gender
      landmark
      isArchived
      lastName
      pincode {
        id
        pincode
      }
      roles
      state
      libraryStaff {
        role
        library {
          id
          name
          libraryNumber
        }
      }
    }
  }
`;
